import { render, staticRenderFns } from "./LoginExterno.vue?vue&type=template&id=0458bdf1&scoped=true&"
import script from "./LoginExterno.vue?vue&type=script&lang=js&"
export * from "./LoginExterno.vue?vue&type=script&lang=js&"
import style0 from "./LoginExterno.vue?vue&type=style&index=0&id=0458bdf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0458bdf1",
  null
  
)

export default component.exports